import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  setItem(key: string, value: any): void {
    const item = {
      value: value
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  setItemWithExpiry(key: string, value: any, ttl: number): void {
    const now = new Date().getTime();
    const item = {
      value: value,
      expiry: now + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  setItemWithExpiryAt(key: string, value: any, expiryDate: Date): void {
    const expiry = expiryDate.getTime();
    const item = {
      value: value,
      expiry: expiry,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getItem(key: string): any {

    const storedData = localStorage.getItem(key);

    if (storedData) {
      const parsedData = JSON.parse(storedData);
      return parsedData.value;
    }

    return null;
  }

  getItemWithExpiry(key: string): any {

    const storedData = localStorage.getItem(key);

    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const now = new Date().getTime();

      if (now < parsedData.expiry) {
        return parsedData.value;
      } else {
        localStorage.removeItem(key);
      }
    }

    return null;
  }

  cleanExpiredItems(): void {
    const now = new Date().getTime();

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      if (key) {
        if (key.startsWith('msal') || key.startsWith('server') || key.startsWith('jwt')) {
          continue;
        }

        const itemStr = localStorage.getItem(key);

        if (itemStr) {
          try {
            const item = JSON.parse(itemStr);

            if (item.expiry && now > item.expiry) {
              localStorage.removeItem(key);
            }
          } catch (e) {
            continue;
          }
        }
      }
    }
  }
}
